import type { TourConfig } from '../../types/tour.types'

// API Access page. Anchors use the view's existing distinctive classes.
// This page is informational (always-on sections), so no optional steps are needed.
const apiAccessTour: TourConfig = {
  id: 'api-access',
  title: 'Build on the TAMI API',
  module: 'Settings',
  routeName: 'ApiAccess',
  order: 18,
  autoStart: true,
  steps: [
    {
      id: 'intro',
      title: 'Put TAMI data inside your own apps',
      body: 'The **TAMI API** lets you enrich companies and contacts, detect their technologies and power your product with real-time B2B data — programmatically, at scale.',
    },
    {
      id: 'credits',
      target: '.credits-highlight',
      placement: 'top',
      title: '500 free credits to start',
      body: 'Kick off with **500 free credits** — a free trial with **no credit card required**. Plenty to test enrichment and wire the API into your workflow before you commit.',
    },
    {
      id: 'get-key',
      target: '.api-hero__btn',
      placement: 'top',
      title: 'Get your API key',
      body: 'Spin up a key in minutes. Your key **authenticates every request**, so keep it safe and start testing straight away.',
    },
    {
      id: 'docs',
      target: '.api-docs',
      placement: 'top',
      title: 'Read the developer docs',
      body: 'A REST API with predictable, resource-oriented endpoints and JSON responses. The **documentation** walks you from your first request through to production.',
    },
    {
      id: 'endpoints',
      target: '.code-block',
      placement: 'top',
      title: 'Explore the endpoints',
      body: 'Here are **example endpoints** to get you going. Authenticate with your key, then call them to enrich records and look up technologies on demand.',
    },
  ],
}

export default apiAccessTour
